import { render, staticRenderFns } from "./KycMobileWooriCrowd.vue?vue&type=template&id=338453c2&"
import script from "./KycMobileWooriCrowd.vue?vue&type=script&lang=js&"
export * from "./KycMobileWooriCrowd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports